import { LoyaltyRule } from './LoyaltyIndex.type';

export function getRewardLabel(type: string): string {
  const labels: Record<string, string> = {
    points: 'Pontos',
    badge: 'Badge',
    program_access: 'Acesso Programa',
    course_access: 'Acesso Curso',
    full_content_access: 'Acesso Total',
  };
  return labels[type] || type;
}

export function getStatusLabel(status: LoyaltyRule['status']): string {
  const labels: Record<string, string> = {
    active: 'Ativo',
    draft: 'Rascunho',
    inactive: 'Inativo',
  };
  return labels[status] || status;
}

